import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export var useRevokeAccessToken = function () {
    var intl = useIntl();
    var _a = useMutation(function (values) {
        return api.base.delete("".concat(config.appUrls.identity, "/api/profile/pats/revoke"), {
            data: values.key,
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        revokeAccessToken: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
